import { getIdToken, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const { REACT_APP_API_URL: baseUrl } = process.env;

const getCurrentToken = () => {
  return new Promise(async (resolve, reject) =>{
    onAuthStateChanged(auth, (_user) => {
      getIdToken(_user).then((token) => {
        console.log(token); 
        resolve(token);
      });
    });
  });
};

const getHeaders = (token) => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${token}`,
});

const getHeadersWithoutToken = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
});

const StatusResponse = {
  get: async (url, auth = true) => {
    let token = null;
    if (auth) token = await getCurrentToken();
    const response = await fetch(baseUrl + url, {
      method: "GET",
      headers: auth ? getHeaders(token) : getHeadersWithoutToken(),
    });

    let serverResponse = await response.json();
    
    return {
      isError: response?.status !== 200  ? true : false,
      status: response?.status,
      resultado: (serverResponse?.resultado || serverResponse) || null ,
      paginacion: serverResponse?.paginacion || null
    }
  },
  getFullUrl: async (url, auth = true) => {
    let token = null;
    if (auth) token = await getCurrentToken();
    const response = await fetch(url, {
      method: "GET",
      headers: auth ? getHeaders(token) : getHeadersWithoutToken(),
    });

    let serverResponse = await response.json();
    
    return {
      isError: response?.status !== 200  ? true : false,
      status: response?.status,
      resultado: (serverResponse?.resultado || serverResponse) || null ,
      paginacion: serverResponse?.paginacion || null
    }
  },
  post: async (url, data, auth = true, type = 1) => {
    let token = null;
    if (auth) token = await getCurrentToken();
    const response = await fetch(baseUrl + url, {
      method: "POST",
      headers: auth ? getHeaders(token) : getHeadersWithoutToken(),
      body: JSON.stringify(data),
    });

    let serverResponse = null
    try {
      if(type === 1) {
        serverResponse = await response.json();
      }
      if(type === 2){
        serverResponse = await response.blob();
      }
    } catch (error) {
      console.log(error)
    }
    
    return {
      isError: response?.status !== 200  ? true : false,
      status: response?.status,
      errores: serverResponse?.errores || null,
      detalle: serverResponse?.detalle || null,
      mensaje: serverResponse?.mensaje || null,
      response: serverResponse || null,
    }
  },
};

export default StatusResponse;